import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Spin, Switch } from "antd";
import AddEvent from "./AddEvent";
import { ROLL_CALL_API_BASE_URL } from "../../RollCall/RollCallConfig/RollCallConfig";
import Table from "../../../../core/pagination/datatable.jsx";
import EditEvent from "./EditEvent.jsx";
import { Edit } from "feather-icons-react/build/IconComponents";

const Events = () => {
  const [tokenData, setTokenData] = useState(null);
  const [eventData, setEventData] = useState([]);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;
    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];
    if (!perms) {
      navigate("/rollcall/dashboard");
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  const fetchVisitorEvents = async () => {
    if (tokenData && superIdData) {
      setLoading(true);

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}Visitor/Pass/getVisitorEvents?SuperId=${superIdData}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${tokenData}`,
            },
          },
        );

        const data = await response.json();

        if (data.status) {
          setEventData(data.ResultData || []);
        } else {
          console.error("Failed to fetch visitor events");
        }
      } catch (error) {
        console.error("Error fetching visitor events:", error.message);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (tokenData && superIdData) {
      fetchVisitorEvents();
    }
  }, [tokenData, superIdData]);

  const columns = [
    {
      title: "Event Name",
      dataIndex: "Name",
      sorter: (a, b) => (a?.Name || "").localeCompare(b?.Name || ""),
      render: (text) => text || "N/A",
    },
    {
      title: "Note",
      dataIndex: "Note",
      sorter: (a, b) => (a?.Note || "").localeCompare(b?.Note || ""),
      render: (text) => text || "N/A",
    },
    {
      title: "Count",
      dataIndex: "Count",
      sorter: (a, b) => Number(a?.Count || 0) - Number(b?.Count || 0),
      render: (count) => count ?? "N/A",
    },

    {
      title: "Status",
      dataIndex: "IsActive",
      key: "IsActive",
      sorter: (a, b) => (a?.IsActive ? 1 : 0) - (b?.IsActive ? 1 : 0),
      render: (isActive) => (
        <Switch
          checked={Boolean(isActive)}
          style={{
            transform: "scale(0.8)",
            transformOrigin: "left center",
          }}
          disabled
        />
      ),
    },
  ];
  if (perm?.Write) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      align: "center",
      render: (_, record) => (
        <div className="action-table-data d-flex justify-content-center">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              onClick={() => {
                setSelectedEvent(record);
                setShowEdit(true);
              }}
            >
              <Edit className="feather-edit text-info" />
            </Link>
          </div>
        </div>
      ),
    });
  }

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Events
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your Events</h6>
              </div>
            </div>

            {perm?.Write && (
              <div className="page-btn mb-3">
                <Link
                  to="#"
                  className="btn btn-success btn-sm"
                  onClick={() => setShowAdd(true)}
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </div>
            )}
          </div>
          {perm.Read ? (
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <div className="search-set">
                  <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                    <div className="col-6 mb-2">
                      <label className="form-label"></label>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="card-body">
                <div className="table-responsive">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large"></Spin>
                      <p>Loading data...</p>
                    </div>
                  ) : (
                    <Table
                      columns={columns}
                      dataSource={eventData}
                      pgno={true}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="card">
              <div className="card-body d-flex justify-content-center">
                <h1>You dont have access to this page</h1>
              </div>
            </div>
          )}
        </div>
      </div>

      <AddEvent
        isOpen={showAdd}
        fetchVisitorEvents={fetchVisitorEvents}
        onClose={() => setShowAdd(false)}
      />
      <EditEvent
        isOpen={showEdit}
        eventData={selectedEvent}
        fetchVisitorEvents={fetchVisitorEvents}
        onClose={() => {
          setShowEdit(false);
          setSelectedEvent(null);
        }}
      />
    </div>
  );
};

export default Events;
